import React, { useState } from 'react';

import FormControl from 'react-bootstrap/FormControl';

import { Modal } from 'components/form/prototypes';

const RejectModal = ({ showModal, setShowModal, callback }) => {

  const [rejection, setRejection] = useState('');

  const handleYes = () => {
    if (!rejection) return;
    setShowModal(false);
    callback(rejection);
  }

  const handleNo = () => {
    setShowModal(false);
  }

  const text = {
    body: (
      <>
        By proceeding, the NCR will be <b><u>REJECTED</u></b>.
        <br />
        <br />
        Please provide a reason for rejecting this NCR:
        <FormControl
          as='textarea'
          onChange={(event) => setRejection(event.target.value)}
          className={!rejection && 'error'}
        />
        <br />
        Are you sure you would like to <b><u>REJECT</u></b> the NCR?
      </>
    ),
    yes: <>Yes, I'm sure</>,
    no: <>No, keep this NCR active</>
  }

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} handleYes={handleYes} handleNo={handleNo} text={text} />
  )
}

export { RejectModal };
